export { default as NewGroupAffiliationsTable } from './NewGroupAffiliationsTable';
